/**
 * Action buttons bar for show details page
 */

import React from 'react';
import { Stack, Button } from '@mui/material';

interface ShowActionsBarProps {
  onBack: () => void;
}

export const ShowActionsBar: React.FC<ShowActionsBarProps> = ({ onBack }) => {
  return (
    <Stack direction="row" spacing={2}>
      <Button variant="outlined" onClick={onBack}>
        Back to Shows
      </Button>
    </Stack>
  );
};
